import { baseApi } from '@/shared/api'
import { DEFAULT_PAGE_SIZE } from '@/shared/lib'
import type {
  OrderCatalogCategoriesQuery,
  OrderCatalogCategory,
  OrderCatalogProductList,
  OrderCatalogProductsQuery,
} from '../model/types'

/** Заказной каталог РБ: дерево узлов и товары узла/поиска. Модификатор уходит строкой запроса. */
export const orderCatalogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Узлы уровня дерева: массив целиком, без пагинации (`?parentId=` — дети узла, иначе корень).
     * Дерево одно для клиента и менеджера глазами клиента — модификатор лишь проверяется бэком.
     */
    getOrderCatalogCategories: build.query<OrderCatalogCategory[], OrderCatalogCategoriesQuery>({
      query: (params) => ({ url: '/catalog/order-rb/categories', params }),
      providesTags: [{ type: 'OrderCatalog', id: 'TREE' }],
    }),

    /**
     * Товары узла (`categoryId`) или поиска (`search`): ровно один отбор — их несовместимость
     * проверяет вызывающий экран, а не склейка на клиенте. Отбор, сортировка, страница и `total`
     * приходят от сервера (правило 11). Цена — вкладка `settlement`, без наценки.
     */
    getOrderCatalogProducts: build.query<OrderCatalogProductList, OrderCatalogProductsQuery>({
      query: ({ page = 1, pageSize = DEFAULT_PAGE_SIZE, ...rest }) => ({
        url: '/catalog/order-rb/products',
        params: { page, pageSize, ...rest },
      }),
      providesTags: [{ type: 'OrderCatalog', id: 'LIST' }],
    }),
  }),
})

export const { useGetOrderCatalogCategoriesQuery, useGetOrderCatalogProductsQuery } =
  orderCatalogApi
